import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CampaignService } from 'app/campaign/services/campaign.service';

@Component({
  selector: 'app-event-cover-fee-settings',
  templateUrl: './event-cover-fee-settings.component.html',
  styleUrls: ['./event-cover-fee-settings.component.scss']
})
export class EventCoverFeeSettingsComponent implements OnInit {


  @Input() formGroupCampaign: UntypedFormGroup = null;

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public campaignService: CampaignService
  ) { }

  ngOnInit(): void {
    const hideCoverFee = this.formGroupCampaign.get('hideCoverFee');
    const coverFeeDefaultOff = this.formGroupCampaign.get('coverFeeDefaultOff');

    hideCoverFee.valueChanges.pipe(
      filter(value => value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      coverFeeDefaultOff.clearValidators();
      coverFeeDefaultOff.disable({ emitEvent: false });
      coverFeeDefaultOff.setValue(false);
    });

    hideCoverFee.valueChanges.pipe(
      filter(value => !value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      coverFeeDefaultOff.enable({ emitEvent: false });
    });
    
    if(hideCoverFee.value) {
      const coverFeeDefaultOff = this.formGroupCampaign.get('coverFeeDefaultOff') as UntypedFormControl;
      coverFeeDefaultOff.disable({ emitEvent: false });
      coverFeeDefaultOff.setValue(false);
    }
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
